import useSWRImmutable from 'swr/immutable'
import { axiosFetcher, type AxiosFetcherKey } from '../../utils/api/axios-fetcher'
import { Servers } from '../../utils/api/servers'
import { useEffect, useState } from 'react'

export function usePortfolios (isAuthorized: boolean, accessToken: string | null): Record<string, Record<string, string[]>> {
  const [portfolios, setPortfolios] = useState<Record<string, Record<string, string[]>>>({})

  const { data, error } = useSWRImmutable<Record<string, Record<string, string[]>>, boolean, AxiosFetcherKey>(
    isAuthorized ? [Servers.STRATEGY_GATEWAY, null, 'configuration/portfolios', accessToken, null] : null,
    axiosFetcher,
  )

  useEffect(() => {
    if (data == null || (error === true)) {
      setPortfolios({})
    } else {
      setPortfolios(data)
    }
  }, [data, error])

  return portfolios
}
